"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateGetUserAttributes = void 0;
const mutateGetUserAttributes = ({ clazz, override, extend }) => {
    Object.entries(extend).forEach(([fnName, extendingFn]) => {
        const original = clazz.prototype.getUserAttributes;
        try {
            if (typeof clazz.prototype[fnName] === 'function')
                clazz.prototype[fnName] = function (...args) {
                    const baseResult = original.apply(this, args);
                    const extendResult = extendingFn.apply(this, args);
                    return { ...baseResult, ...extendResult };
                };
        }
        catch (e) { }
    });
    Object.entries(override).forEach(([fnName, overrideFn]) => {
        const original = clazz.prototype.getUserAttributes;
        try {
            if (typeof clazz.prototype[fnName] === 'function')
                clazz.prototype[fnName] = function (...args) {
                    const result = overrideFn.apply(this, args);
                    return result;
                };
        }
        catch (e) { }
    });
};
exports.mutateGetUserAttributes = mutateGetUserAttributes;
